/** @type {string[]} */
const CLIENTS_WITH_TOKEN = JSON.parse(
  process.env.GATSBY_CLIENTS_WITH_TOKEN || "[]",
)

/**
 * check if the token should be appended to the client callback url
 *
 * @param {string} clientId
 * @returns {boolean}
 */
export function shouldAppendToken(clientId) {
  return CLIENTS_WITH_TOKEN.includes(clientId)
}

/**
 * Generate url for redirecting to client website with code, tokens and state
 *
 * @param {{
 *  callbackUri: string
 *  code: string
 *  tokens?: {
 *    idToken: string
 *    refreshToken: string
 *    accessToken: string
 *  }
 *  state?: string | null
 * }} params
 * @returns {string}
 */
export function generateClientCallbackUrl({callbackUri, code, tokens, state}) {
  const url = new URL(callbackUri)
  url.searchParams.set("code", code)

  if (tokens) {
    url.searchParams.set("refresh_token", tokens.refreshToken)
    url.searchParams.set("id_token", tokens.idToken)
    url.searchParams.set("access_token", tokens.accessToken)
  }
  if (state) {
    url.searchParams.set("state", state)
  }
  return url.href
}
